import React from 'react'

const SvgFacebookLogo = () =>{
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="18"><path fill="#000" d="M0 5.637h1.834V3.91c-.108-.97.108-1.941.646-2.696C3.127.352 3.907.142 5.285.029 6.364-.08 7.549.137 8.628.352l-.324 2.696c-.43-.108-.97-.216-1.51-.216-.754 0-1.401.216-1.401.971v2.05h2.911l-.215 2.372H5.393v8.952h-3.56V8.225H0V5.637z"/></svg>
  )
}

export default SvgFacebookLogo